import {useEffect} from "react";

import {useGlobalEventDispatch} from "~/contexts/event/GlobalEventBusContext";

/**
 * A hook that listens for global keydown, keyup, focus, and blur events on the window
 * object and dispatches them through the global event bus.
 */
export function useGlobalKeyboardEvents() {
  const dispatch = useGlobalEventDispatch();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      dispatch("keydown", event);
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      dispatch("keyup", event);
    };

    const handleFocus = (event: FocusEvent) => {
      dispatch("focus", event);
    };

    const handleBlur = (event: FocusEvent) => {
      dispatch("blur", event);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    // Cleanup listeners when the component unmounts.
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, [dispatch]);
}
